import { getBroadcasters } from '@optools/services/statsapi/broadcasters';
import { getTeams } from '@optools/services/statsapi/teams';
import { Team } from '@optools/services/statsapi/types';

import { apiSlice } from './apiSlice';
import { selectStatsBaseUrl } from './configApiSlice';
import { RootState } from './store';

export const statsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    callSigns: builder.query<string[], void>({
      queryFn: async (_: void, { getState }) => {
        const baseUrl = selectStatsBaseUrl(getState() as RootState);
        try {
          const response = await getBroadcasters(baseUrl);
          const data = response.map((broadcaster) => broadcaster.callSign);
          return { data };
        } catch (error: unknown) {
          return { error: `CallSign (StatsAPI) Error: ${(error as Error)?.message}` };
        }
      },
    }),
    teams: builder.query<Team[], number[] | void>({
      queryFn: async (sportIds: number[] = [1], { getState }) => {
        const baseUrl = selectStatsBaseUrl(getState() as RootState);
        try {
          const response = await getTeams(baseUrl, sportIds);
          const alphabetized = response.toSorted((a, b) => a.name.localeCompare(b.name));

          return { data: alphabetized };
        } catch (error: unknown) {
          return { error: `Teams (StatsAPI) Error: ${(error as Error)?.message}` };
        }
      },
    }),
  }),
});

export const { useCallSignsQuery, useTeamsQuery } = statsApiSlice;
